import ReduxRestEntity from '../../../../utils/reduxRestEntity';
import campaignAnalyticsAPI from '../../../../utils/api/campaignAnalyticsAPI';

const entity = new ReduxRestEntity({
  name: 'campaignAnalytics',
  api: campaignAnalyticsAPI(),
});

export default entity;
